import React, { useContext, useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import InputContext from '@totem/components/ui_components/reportSettings/InputContext';
import api from '@totem/utilities/api';
import { DEVICES_PAGINATION_ENDPOINT } from '@totem/utilities/endpoints';
import fileUtilities from '@totem/utilities/fileUtilities';

type Props = {
  deviceExportEndPoint?: string;
};

const DeviceExportWebSockets = ({ deviceExportEndPoint }: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const { buildParameters } = useContext(InputContext);

  const exportData = async () => {
    setLoading(true);

    const params = buildParameters();

    const deviceUrl =
      typeof deviceExportEndPoint !== 'undefined' &&
      deviceExportEndPoint !== null
        ? deviceExportEndPoint
        : DEVICES_PAGINATION_ENDPOINT;

    const { data } = await api.post(`${deviceUrl}/export/ws`, params);
    fileUtilities.downloadFile('devices', data);

    setLoading(false);
  };

  return (
    <Button
      type="default"
      icon={<DownloadOutlined />}
      onClick={exportData}
      loading={loading}
    >
      Export CSV
    </Button>
  );
};

export default DeviceExportWebSockets;
